<template>
  <div class="timetable">
    <TimeScale class="timescale" title="klo" :double="$mq | mq({tablet: true, desktop: false})"></TimeScale>
    <div class="days-wrapper">
      <BookingList class="bookings"
        @click="handleClick($event)"
        v-for="day in dayArray" :key="day.date"
        :style="style"
        :bookings="getDayByRoom(day.date, roomId)"
        :day="day"
        :info="true">
      </BookingList>
    </div>
  </div>
</template>

<script>
import TimeScale from '@/components/TimeScale'
import BookingList from '@/components/BookingList'

import TimeUtils from './../utils/TimeUtils'
import { mapGetters } from 'vuex';

import Booking from './../store/modules/booking/types';

const dayNames = ['Maanantai', 'Tiistai', 'Keskiviikko', 'Torstai', 'Perjantai', 'Lauantai', 'Sunnuntai'];

export default {
  name: 'TimeTableWeek',
  components: { TimeScale, BookingList },
  props: ['bookings', 'date', 'roomId', 'cols'],
  computed: {
    style () {
      const cols = this.cols || 7;
      const width = (100 / cols) + '%';
      return { width };
    },
    dayArray () {
      const dates = TimeUtils.getDatesForWeek(this.date);
      const array = dates.map((d, i) => {
        return {date: d, display: TimeUtils.toShortFIN(d), name: dayNames[i]};
      })
      return array;
    },
    ...mapGetters('Booking', [Booking.getters.GET_DAY_BY_ROOM])
  },
  methods: {
    handleClick (e) {
      console.log('klikki', e);

      this.$router.push({
        name: 'BookingCreateView',
        params: { room: this.roomId, startTime: e.hour, date: e.date }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/color.scss';

.timetable {
  position: relative;
  margin-bottom: 4em;
}

.days-wrapper {
  width: calc(100% - 3em);
  left: 3em;
  position: absolute;
  top: 0;
  display: flex;
  flex-flow: row wrap;
  height: 100%;
  margin-bottom: 3em;
}

.bookings {
  width: 20%;
  border-right: 1px solid $table-border-color;
  box-sizing: border-box;
}

</style>



// WEBPACK FOOTER //
// src/components/TimeTableWeek.vue